import React from "react";
import { IoClose } from "react-icons/io5";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import { FaCamera } from "react-icons/fa";
import { IoDocumentOutline } from "react-icons/io5";
import { FaSave } from "react-icons/fa";
import { GiCrossMark } from "react-icons/gi";
import { IoPrintSharp } from "react-icons/io5";
import { useState, useEffect, useRef } from "react";
import "../../../CSS/RegisterEmployee.css";
import axios from "axios";
import moment from "moment";
import LoadingScreen from "../../LoadingScreen";
import Select from "react-select";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import vehicleMasterData, {
  vehicleAction,
} from "../../../store/VehicleMasterERP";
import { BsFileEarmarkPdf } from "react-icons/bs";
import { RiFileExcel2Line } from "react-icons/ri";
import ExcelJS from "exceljs";
import jsPDF from "jspdf";
import "jspdf-autotable";

// Importing tabs
import OtherInformationAsset from "./HeaderInfoTabs/OtherInformationAsset";
import Documentation from "./HeaderInfoTabs/Documentation";
import InsuranceDetails from "./HeaderInfoTabs/InsuranceDetails";

const HeaderInformation = () => {
  const [bottomtabs, setBottomTabs] = useState([
    {
      id: 1,
      title: "Insurance Details",
      content: <InsuranceDetails />,
    },
    {
      id: 2,
      title: "Documentation",
      content: <Documentation />,
    },
    {
      id: 3,
      title: "Notes",
      content: "",
    },
    {
      id: 4,
      title: "Other Information of Asset",
      content: <OtherInformationAsset />,
    },
  ]);

  const [selectedTabIndexBottom, setSelectedTabIndexBottom] = useState(0);
  const handleTabSelectBottom = (index) => {
    setSelectedTabIndexBottom(index);
  };

  const addItem = vehicleMasterData((state) => state.addItem);
  const addItems = vehicleAction((state) => state.addItem);
  const value = vehicleAction((state) => state.value);
  console.log(value);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const sessiontoken = window.sessionStorage.getItem("session-token");
  const state = useSelector((state) => state.changeTheState);
  const user = state?.user?.emailId?.split("@")[0];
  const location = useLocation();
  const menu = location.state ? location.state.menu : null;
  const authToken = window.sessionStorage.getItem("auth-token");
  const BASEURL_GLOBAL = process.env.REACT_APP_BASEURL_GLOBAL;
  const BASEURL = process.env.REACT_APP_BASEURL;
  const [isLoading, setIsLoading] = useState(true);

  // VEHICLE RELATED
  const [make, setMake] = useState("");
  const [model, setModel] = useState("");
  const [trailerType, setTrailerType] = useState("");
  const [assetCategory, setAssetCategory] = useState("");

  const [formData, setFormData] = useState({
    histData: [],
    vehicleStatus: "ACTIVE",
    engineNo: "",
    engineNoList: [],
    trailer1: "",
    trailer2: "",
    trailerList: [],
    registrationNo: "",
    showRegistration: false,
    searchRegistration: "",
    colorOfBody: "",
    trailer: false,
    trailerAttached: false,
    trailerAttachedList: [],
    attachedTrailerType: "",
    chasisNo: "",
    fleetNo: "",
    assetCategory: "",
    typeOfBody: "",
    typeOfBodyList: [],
    subcon: "",
    subconList: [],
    subconSearch: "",
    showSubCon: false,
    subconContractingAsset: false,
    make: "",
    client: "",
    clientList: [],
    showClient: false,
    searchClient: "",
    clientAsset: false,
    assetRating: "",
    transmission: "",
    transMissionList: [],
    model: "",
    grossWeight: "",
    singleDouble: "",
    manufacturingYear: "",
    carryingCapacity: "",
    department: "",
    departmentList: [],
    fuelCapacity: "",
    trailerType: "",
    totalWeight: "",
    tareWeight: "",
    tractorType: "",
    tractorTypeList: [],
    dispatcher: "",
    dispatcherList: [],
    driverName: "",
    showDriver: false,
    driverList: [],
    registrationDate: new Date().toISOString(),
    registeredCountry: "",
    countryList: [],
    registrationName: "",
    addrOnReg: "",
    division: "",
    divisionList: [],
  });

  const handleChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  // MAKE AND MODEL POPUP
  const [data, setData] = useState([]);
  const [vehicleMake, setVehicleMake] = useState("");
  const [vehicleModel, setVehicleModel] = useState("");
  const [makeList, setMakeList] = useState([]);
  const [modelList, setModelList] = useState([]);
  const [showMakeAndModel, setShowMakeAndModel] = useState(false);

  // MAKE POPUP
  const [showMakes, setShowMakes] = useState(false);
  const [makeData, setMakeData] = useState([]);
  const [vehicleMakeMAKE, setVehicleMakeMAKE] = useState("");
  const [selectedRowIndex, setselectedRowIndex] = useState(null);
  const [makeModelData, setMakeModelData] = useState([]);

  // MODEL POPUP
  const [showModel, setShowModel] = useState(false);
  const [modelData, setModelData] = useState([]);
  const [vehicleModelMODEL, setVehicleModelMODEL] = useState("");
  const [selectedRowIndexMODEL, setselectedRowIndexMODEL] = useState(null);

  // TRAILER TYPE POPUP
  const [showTrailerType, setShowTrailerType] = useState(false);
  const [trailerTypedata, setTrailerTypeData] = useState([]);
  const [trailerTypeTT, setTrailerTypeTT] = useState("");
  const [selectedRowIndexTT, setselectedRowIndexTT] = useState(null);
  const [vehicleDataTT, setVehicleDataTT] = useState([]);

  // VEHICLE CATEGORY POPUP
  const [showVehicleCategory, setShowVehicleCategory] = useState(false);
  const [vehicleCategorydata, setVehicleCategoryData] = useState([]);
  const [VehicleCategoryVC, setVehicleCategoryVC] = useState("");
  const [selectedRowIndexVC, setselectedRowIndexVC] = useState(null);
  const [vehicleDataVC, setVehicleDataVC] = useState([]);

  const filterRegistration = formData?.histData?.filter((item) => {
    const searchData = formData?.searchRegistration
      ?.toLowerCase()
      ?.split(" ")
      .filter(Boolean);

    if (formData?.searchRegistration.length === 0) {
      return true;
    }

    const textMatch = searchData.every((term) =>
      [
        "OM_VEHICLE_REG_NO",
        "OM_VEHICLE_CHASSIS_NO",
        "OM_VEHICLE_ENGINE_NO",
        "OM_VEHICLE_MAKE",
        "OM_VEHICLE_MODEL",
        "OM_VEHICLE_TRAILER_ATTACHED",
      ].some((key) => {
        const columnValue = String(item[key]).toLowerCase();
        return columnValue.includes(term);
      }),
    );

    return textMatch;
  });

  const filterSubCon = formData?.subconList?.filter((item) => {
    const searchData = formData?.subconSearch
      ?.toLowerCase()
      ?.split(" ")
      .filter(Boolean);

    if (formData?.subconSearch.length === 0) {
      return true;
    }

    const textMatch = searchData.every((term) =>
      ["VENDOR CODE", "VENDOR NAME"].some((key) => {
        const columnValue = String(item[key]).toLowerCase();
        return columnValue.includes(term);
      }),
    );

    return textMatch;
  });

  const filterClient = formData?.clientList?.filter((item) => {
    const searchData = formData?.searchClient
      ?.toLowerCase()
      ?.split(" ")
      .filter(Boolean);

    if (formData?.searchClient.length === 0) {
      return true;
    }

    const textMatch = searchData.every((term) =>
      ["CLIENT NAME", "CLIENT CODE"].some((key) => {
        const columnValue = String(item[key]).toLowerCase();
        return columnValue.includes(term);
      }),
    );

    return textMatch;
  });

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=459`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((res) => {
        setMakeModelData(res?.data);
      })
      .catch((err) => {
        console.log("Error While fetching 459", err);
        setIsLoading(false);
      });

    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1109`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((res) => {
        setMakeData(res?.data);
        setMakeList(res?.data);
      })
      .catch((err) => {
        setIsLoading(false);
        console.log("Error While fetching 1109", err);
      });

    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=673`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((res) => {
        setModelList(res?.data);
        setModelData(res?.data);
      })
      .catch((err) => {
        setIsLoading(false);
        console.log("Error While fetching 673", err);
      });

    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1110`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((res) => {
        setTrailerTypeData(res?.data);
      })
      .catch((err) => {
        setIsLoading(false);
        console.log("Error While fetching 1110", err);
      });

    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1111`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((res) => {
        setVehicleCategoryData(res?.data);
      })
      .catch((err) => {
        setIsLoading(false);
        console.log("Error While fetching 1111", err);
      });

    // 660 - SubCon Supplier
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=660`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((res) => {
        handleChange("subconList", res?.data);
      })
      .catch((err) => {
        setIsLoading(false);
        console.log("Error While fetching 660", err);
      });

    // 598 - Client
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=598`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((res) => {
        handleChange("clientList", res?.data);
      })
      .catch((err) => {
        setIsLoading(false);
        console.log("Error While fetching 598", err);
      });

    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=381`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((response) => {
        setEmpId(response.data[0].EMPID);
      })
      .catch((err) => {
        console.log("Error While fetching 381");
      });

    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=671`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((response) => {
        setVehicles(response.data);
      })
      .catch((err) => {
        console.log("Error While fetching 671");
      });

    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=347`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((response) => {
        setDEPARTMENTVal(response.data);
      })
      .catch((err) => {
        console.log("Error While fetching 347");
      });

    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=348`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((response) => {
        setDesigVal(response.data);
      })
      .catch((err) => {
        console.log("Error While fetching 348");
      });

    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=611`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((response) => {
        const sortedData = response?.data?.sort(
          (a, b) => a?.[" EMPLOYEE ID"] - b?.[" EMPLOYEE ID"],
        );
        setEmployeeList(sortedData);
      })
      .catch((err) => {
        console.log("error while fetching 611");
      });

    axios
      .post(
        `${BASEURL_GLOBAL}/globalGraphQL`,
        {
          query:
            "query ($viewname: String!, $columns: [String!]) { globalView(viewname: $viewname, columns: $columns) }",
          variables: {
            viewname: "1362",
            columns: [
              "OM_VEHICLE_TRAILER_TYPE",
              "OM_VEHICLE_TYPE",
              "OM_VEHICLE_REG_NO",
              "OM_VEHICLE_CHASSIS_NO",
              "OM_VEHICLE_ENGINE_NO",
              "OM_VEHICLE_MAKE",
              "OM_VEHICLE_MODEL",
              "OM_VEHICLE_TRAILER_ATTACHED",
            ],
          },
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessiontoken,
          },
        },
      )
      .then((res) => {
        const filter = res?.data?.data?.globalView?.filter(
          (item) => item.OT_CONTRACT_STATUS !== 0,
        );
        const datas = res?.data?.data?.globalView;
        setVehicleDataTT(datas);
        setVehicleDataVC(datas);
        handleChange("histData", datas);
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        console.log("Error While fetching 1362", err);
      });
  };

  function getDataFromVehicleRegNo(vehicle) {
    axios
      .get(
        `${BASEURL_GLOBAL}/globalViewHandler?viewname=1362&OM_VEHICLE_REG_NO=${encodeURIComponent(vehicle)}`,
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessiontoken,
          },
        },
      )
      .then((res) => {
        const row = res?.data[0] || [];
        console.log(row);

        handleChange("vehicleStatus", row?.["OM_VEHICLE_STATUS"]);
        handleChange("registrationNo", row?.["OM_VEHICLE_REG_NO"]);
        handleChange("chasisNo", row?.["OM_VEHICLE_CHASSIS_NO"]);
        handleChange("typeOfBody", row?.["OM_VEHICLE_TYPE_OF_BODY"]);
        handleChange("make", row?.["OM_VEHICLE_MAKE"]);
        handleChange("assetRating", row?.["OM_VEHICLE_RATING_CC"]);
        handleChange("grossWeight", row?.["OM_VEHICLE_GROSS_WT"]);
        handleChange("carryingCapacity", row?.["OM_VEHICLE_CARRYING_CAP"]);
        handleChange("tareWeight", row?.["OM_VEHICLE_TARE_WT"]);
        handleChange("trailerType", row?.["OM_VEHICLE_TRAILER_TYPE"]);
        handleChange("tractorType", row?.["OM_VEHICLE_TRACTOR_TYPE"]);
        handleChange("registrationDate", row?.["OM_VEHICLE_REG_DATE"]);
        handleChange("addrOnReg", row?.["OM_VEHICLE_ADDRESS_ON_REG1"]);
        handleChange("engineNo", row?.["OM_VEHICLE_ENGINE_NO"]);
        handleChange("colorOfBody", row?.["OM_VEHICLE_COLOR_OF_BODY"]);
        handleChange("trailer", row?.["OM_VEHICLE_TRAILER"]);
        handleChange(
          "trailerAttached",
          row?.["OM_VEHICLE_TRAILER_ATTACHED_YES_NO"],
        );
        handleChange("trailer1", row?.["OM_VEHICLE_TRAILER_ATTACHED"]);
        handleChange("trailer2", row?.["OM_VEHICLE_TRAILER_ATTACHED_2"]);
        handleChange("attachedTrailerType", row?.["OM_VEHICLE_TYPE"]);
        handleChange("fleetNo", row?.["OM_VEHICLE_FLEET_NO"]);
        handleChange("assetCategory", row?.["OM_VEHICLE_TYPE"]);
        handleChange(
          "subconContractingAsset",
          row?.["OM_VEHICLE_SUBCONTRACTING"],
        );
        handleChange("clientAsset", row?.["OM_VEHICLE_CLIENT_OWNED"]);
        handleChange("transmission", row?.["OM_VEHICLE_TRANSMISSION"]);
        handleChange("model", row?.["OM_VEHICLE_MODEL"]);
        handleChange("singleDouble", row?.["OM_VEHICLE_SINGLE_DOUBLE_DIFF"]);
        handleChange("manufacturingYear", row?.["OM_VEHICLE_MFG_YEAR"]);
        handleChange("department", row?.["OM_VEHICLE_DEPARTMENT"]);
        handleChange("fuelCapacity", row?.["OM_VEHICLE_FUEL_CAPACITY"]);
        handleChange("dispatcher", row?.["OM_VEHICLE_DISPATCHER"]);
        handleChange("driverName", row?.["DRIVER"]);
        handleChange("registeredCountry", row?.["OM_VEHICLE_COUNTRY"]);
        handleChange("registrationName", row?.["OM_VEHICLE_NAME_REGISTRATION"]);
        handleChange("division", row?.["OM_VEHICLE_TRANS_DIVISION_CURRENT"]);

        const clients = formData?.clientList?.find(
          (item) => item?.["CLIENT CODE"] === row?.["OM_VEHICLE_CLIENT_CODE"],
        );
        handleChange("client", clients?.["CLIENT NAME"]);

        const subcons = formData?.subconList?.find(
          (item) =>
            item?.["VENDOR CODE"] ===
            row?.["OM_VEHICLE_SUBCONTRACTING_COMPANY"],
        );
        handleChange("subcon", subcons?.["VENDOR NAME"]);
        handleChange("showRegistration", false);
      })
      .catch((err) => {
        console.log("Error While fetching 1362", err);
        setIsLoading(false);
      });
  }

  function getDataFromMake(make) {
    setIsLoading(true);

    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=459&MAKE=${make}`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((res) => {
        setData(res?.data);
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        console.log("Error While fetching 459", err);
      });
  }

  //  - MAKE RELATED
  // Adding and Removing from the Grid
  const AddToGrid = () => {
    const newValue = {
      MAKE: vehicleMakeMAKE,
    };
    setMakeData([...makeData, newValue]);
    setVehicleMakeMAKE("");
  };

  const RemoveFromGrid = () => {
    if (makeData.length > 0) {
      const updatedValues = [...makeData];
      if (
        selectedRowIndex !== null &&
        selectedRowIndex >= 0 &&
        selectedRowIndex < updatedValues.length
      ) {
        updatedValues.splice(selectedRowIndex, 1);
        setselectedRowIndex(null);
      } else {
        updatedValues.pop();
      }
      setMakeData(updatedValues);
      setVehicleMakeMAKE("");
    } else {
      alert("Please add data details First");
    }
  };

  // MODEL RELATED
  // Adding and Removing from the Grid
  const AddToGridMODEL = () => {
    const newValue = {
      MODEL: vehicleModelMODEL,
    };
    setModelData([...modelData, newValue]);
    setVehicleModelMODEL("");
  };

  const RemoveFromGridMODEL = () => {
    if (modelData.length > 0) {
      const updatedValues = [...modelData];
      if (
        selectedRowIndexMODEL !== null &&
        selectedRowIndexMODEL >= 0 &&
        selectedRowIndexMODEL < updatedValues.length
      ) {
        updatedValues.splice(selectedRowIndexMODEL, 1);
        setselectedRowIndexMODEL(null);
      } else {
        updatedValues.pop();
      }
      setModelData(updatedValues);
      setVehicleModelMODEL("");
    } else {
      alert("Please add data details First");
    }
  };

  // TRAILER TYPE RELATED

  // Adding and Removing from the Grid
  const AddToGridTT = () => {
    const newValue = {
      TRAILERTYPE: trailerTypeTT,
    };
    setTrailerTypeData([...trailerTypedata, newValue]);
    setTrailerTypeTT("");
  };

  const RemoveFromGridTT = () => {
    if (trailerTypedata.length > 0) {
      const updatedValues = [...trailerTypedata];
      if (
        selectedRowIndexTT !== null &&
        selectedRowIndexTT >= 0 &&
        selectedRowIndexTT < updatedValues.length
      ) {
        updatedValues.splice(selectedRowIndexTT, 1);
        setselectedRowIndexTT(null);
      } else {
        updatedValues.pop();
      }
      setTrailerTypeTT(updatedValues);
      setTrailerTypeTT("");
    } else {
      alert("Please add data details First");
    }
  };

  // VEHICLE CATEGORY RELATED
  // Adding and Removing from the Grid
  const AddToGridVC = () => {
    const newValue = {
      OM_VEHICLE_CATEGORY_NAME: VehicleCategoryVC,
    };
    setVehicleCategoryData([...vehicleCategorydata, newValue]);
    setVehicleCategoryVC("");
  };

  const RemoveFromGridVC = () => {
    if (vehicleCategorydata.length > 0) {
      const updatedValues = [...vehicleCategorydata];
      if (
        selectedRowIndexVC !== null &&
        selectedRowIndexVC >= 0 &&
        selectedRowIndexVC < updatedValues.length
      ) {
        updatedValues.splice(selectedRowIndexVC, 1);
        setselectedRowIndexVC(null);
      } else {
        updatedValues.pop();
      }
      setVehicleCategoryData(updatedValues);
      setVehicleCategoryVC("");
    } else {
      alert("Please add data details First");
    }
  };

  // *********** EMPLOYEE MASTER POPUP *************

  const useSelect = (initialState) => {
    const [selectedOption, setSelectedOption] = useState(initialState);

    const handleSelectChange = (selectedOption) => {
      setSelectedOption(selectedOption.value);
    };

    return [selectedOption, handleSelectChange];
  };

  const LoggedInUserName = state?.user?.emailId?.split("@")[0].toUpperCase();
  const initialValues = {
    EMPCODE: "",
    EMPNAME: "",
    ACCOUNTNO: "",
    // JOINDATE: "",
    NATIONALID: "",
    TELEPHONE: "",
    EMAIL: "",
    OVERTIME: 0,
    FREEZE: 0,
    CASUAL: 1, // Default to Yes (1)
    SUBCONTRACTED: 0, // Default to No (0)
    IMAGENAME: "",
    CONFIRM: 0,
    NOTES: "",
    PORTPASS: 0,
    PORTPASSNO: "",
    // PORTPASSEXPIRY: "",
  };

  const [formInput, setFormInput] = useState(initialValues);
  const [JOINDATE, setJOINDATE] = useState("");
  const [PORTPASSPORTPASSEXPIRY, setPORTPASSPORTPASSEXPIRY] = useState("");
  const [section1, setSection1] = useState(true);
  const [desigVal, setDesigVal] = useState([]);
  const [DEPARTMENTVal, setDEPARTMENTVal] = useState([]);
  const [vehicles, setVehicles] = useState([]);
  const [dispPicture, setDispPicture] = useState("");
  const [picture, setPicture] = useState(null);
  const [cameraOn, setCameraOn] = useState(false);
  const [captured, setCaptured] = useState(false);
  const videoRef = useRef(null);
  const canvasRef = useRef(null);

  const [fileUpload, setFileUpload] = useState(null);
  const [filePreview, setFilePreview] = useState(false);
  const [hide, sethide] = useState(true);
  const [empidPass, setEmpId] = useState("");
  const [designation, setDesignation] = useSelect("");
  const [department, setDepartment] = useSelect("");
  const [vehicleAllocated, setVehicleAllocated] = useSelect("");
  const [previousDesignation, setPreviousDesignation] = useState("");

  const [employeeList, setEmployeeList] = useState([]);
  const [showEmployees, setShowEmployees] = useState(false);
  const [searchEmployees, setSearchEmployees] = useState("");

  const filterEmployee = employeeList?.filter((item) => {
    const searchData = searchEmployees
      ?.toLowerCase()
      .split(" ")
      .filter(Boolean);

    if (searchData.length === 0) {
      return true;
    }

    const textMatch = searchData.every((term) => {
      return [
        " EMPLOYEE ID",
        "EMPLOYEE CODE",
        "EMPLOYEE NAME",
        "NATIONAL ID NO",
        "TELEPHONE NO",
        "DESIGNATION",
        "DEPARTMENT",
        "EMAIL",
      ].some((key) => {
        const columnValue = String(item[key]).toLowerCase();
        return columnValue.includes(term);
      });
    });

    return textMatch;
  });

  // Reset vehicleAllocated if designation changes
  useEffect(() => {
    if (previousDesignation && designation !== "DRIVER") {
      setVehicleAllocated("");
    }
    setPreviousDesignation(designation);
  }, [designation, previousDesignation]);
  const handleInputItem = (e) => {
    const { name, value } = e.target;
    setFormInput({ ...formInput, [name]: value });
  };

  function tofixnumber(e) {
    const input = e.target;
    const TELEPHONE = input.value.replace(/\D/g, "");

    if (TELEPHONE.length > 15) {
      const givenvalue = TELEPHONE.replace(/(\d{15})/);
      input.value = givenvalue;
    }
  }

  const openCamera = async () => {
    setSection1(false);
    setCameraOn(true);

    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: true });
      if (videoRef.current) {
        videoRef.current.srcObject = stream;
        videoRef.current.play();
      }
    } catch (error) {
      // Handle the error or show a message to the user
    }
  };

  const capturePicture = () => {
    const video = videoRef.current;
    const canvas = canvasRef.current;
    if (!video || !video.srcObject) {
      return;
    }

    // Rest of the code for capturing the picture
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    canvas.getContext("2d").drawImage(video, 0, 0, canvas.width, canvas.height);

    const pictureData = canvas.toDataURL();
    canvas.toBlob((blob) => {
      setPicture(blob);
    });
    setDispPicture(pictureData);

    // Stop video tracks
    const videoTracks = video.srcObject.getTracks();
    videoTracks.forEach((track) => track.stop());

    setCaptured(true);
    setCameraOn(false);
  };

  const retakePicture = () => {
    setPicture(null);
    setDispPicture("");
    setCaptured(false);
    openCamera();
  };
  function handlePictureUpload(e) {
    const file = e.target.files[0];
    setPicture(file);

    const imageURL = URL.createObjectURL(file);
    setDispPicture(imageURL);
  }
  function handleRegister(e) {
    if (picture === "") {
      alert("Upload image");
      return;
    }
    const vehiclepush =
      vehicleAllocated === undefined ? null : vehicleAllocated;
    e.preventDefault();
    setIsLoading(true);
    const formData = new FormData();
    // formData.append("data", JSON.stringify(formInput));
    formData.append("EMPNO", empidPass);
    formData.append("EMPCODE", formInput.EMPCODE);
    formData.append("EMPNAME", formInput.EMPNAME);
    formData.append("ACCOUNTNO", formInput.ACCOUNTNO);
    formData.append("NATIONALID", formInput.NATIONALID);
    formData.append("TELEPHONE", formInput.TELEPHONE);
    formData.append("EMAIL", formInput.EMAIL);
    formData.append("OVERTIME", formInput.OVERTIME);
    formData.append("DESIGNATION", designation);
    formData.append("DEPARTMENT", department);
    formData.append("FREEZE", Number(formInput.FREEZE));
    formData.append("VEHICLEALLOCATED", vehiclepush);
    formData.append("CASUAL", Number(formInput.CASUAL));
    formData.append("SUBCONTRACTED", Number(formInput.SUBCONTRACTED));
    formData.append("CREATEDBY", LoggedInUserName);
    formData.append("IMAGENAME", picture?.name);
    formData.append("CONFIRM", Number(formInput.CONFIRM));
    formData.append("NOTES", formInput.NOTES);
    formData.append("PORTPASS", Number(formInput.PORTPASS));
    formData.append("PORTPASSNO", formInput.PORTPASSNO);
    formData.append("JOINDATE", JOINDATE);
    formData.append("PORTPASSEXPIRY", PORTPASSPORTPASSEXPIRY);
    formData.append("imageValue", picture);
    axios
      .post(`${BASEURL_GLOBAL}/globalSpHandler?spname=130`, formData, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((response) => {
        if (response.data.message === "niet") {
          alert("Employee code already exists!");
          setIsLoading(false);
        } else {
          alert(response.data.message);
          setIsLoading(false);
          window.location.reload();
        }
      });
  }

  const renderFilePreview = () => {
    if (fileUpload) {
      const fileType = fileUpload.type.split("/")[1];

      if (fileType === "pdf") {
        return (
          <embed
            src={URL.createObjectURL(fileUpload)}
            type="application/pdf"
            width="100%"
            height="500px"
          />
        );
      } else if (
        ["jpg", "jpeg", "png", "heic", "heif", "webp"].includes(fileType)
      ) {
        return <img src={URL.createObjectURL(fileUpload)} />;
      }

      return <p>Preview not available for this file type.</p>;
    }
  };

  // ******************** SAVE VEHICLE MASTER **********************************

  useEffect(() => {
    if (value !== undefined) {
      if (value === "SAVE") {
        Save();
        addItems("");
      }
    }
  }, [value]);

  async function Save() {
    if (!formData?.registrationNo) {
      alert("Kindly Supply the Registration No");
      return;
    }

    if (!formData?.fleetNo) {
      alert("Kindly Supply Fleet No");
      return;
    }

    if (!formData?.singleDouble) {
      alert("Kindly Supply Single/Double Diff");
      return;
    }

    if (!formData?.chasisNo) {
      alert("Kindly Supply the Chasis No");
      return;
    }

    setIsLoading(true);
    try {
      const response = await axios.post(
        `${BASEURL_GLOBAL}/globalSpHandler?spname=232`,
        {
          OM_VEHICLE_REG_NO: formData?.registrationNo
            ? formData?.registrationNo
            : "",
          OM_VEHICLE_CREATED_BY: user,
          OM_VEHICLE_DISPATCHER: formData?.dispatcher
            ? formData?.dispatcher
            : "",
          OM_VEHICLE_PROPELLER_1_SERIAL: "",
          OM_VEHICLE_PROPELLER_2_SERIAL: "",
          OM_VEHICLE_FLEET_NO: formData?.fleetNo ? formData?.fleetNo : "",
          OM_VEHICLE_SINGLE_DOUBLE_DIFF: formData?.singleDouble
            ? formData?.singleDouble
            : "",
          OM_VEHICLE_PAX: 0,
          OT_VEHICLE_TRAMIGO_IMEI_NO: "",
          OM_VEHICLE_TRANS_DIVISION_CURRENT: formData?.division
            ? formData?.division
            : "",
          OM_VEHICLE_OPENING_ODOMETER_READING: 0,
          OM_VEHICLE_OPENING_ODOMETER_READING_DATE: "",
          OM_VEHICLE_OPENING_KM_READING: 0,
          OM_VEHICLE_OPENING_KM_READING_DATE: "",
          OM_VEHICLE_TRAILER: "",
          OM_VEHICLE_STATUS: "",
          OM_VEHICLE_CHASSIS_NO: formData?.chasisNo ? formData?.chasisNo : "",
          OM_VEHICLE_TYPE: "",
          OM_VEHICLE_SUBCONTRACTING:
            formData?.subconContractingAsset === true ? 1 : 0,
          OM_VEHICLE_SUBCONTRACTING_COMPANY: "",
          OM_VEHICLE_SUBCONTRACTING_COMPANY_CODE: formData?.subcon
            ? formData?.subcon
            : "",
          OM_VEHICLE_TYPE_OF_BODY: formData?.typeOfBody
            ? formData?.typeOfBody
            : "",
          OM_VEHICLE_TRAILER_TYPE: formData?.trailerType
            ? formData?.trailerType
            : "",
          OM_VEHICLE_TRACTOR_TYPE: "",
          OM_VEHICLE_COUNTRY: "",
          OM_VEHICLE_COLOR_OF_BODY: "",
          OM_VEHICLE_MFG_YEAR: formData?.manufacturingYear
            ? Number(formData?.manufacturingYear)
            : 0,
          OM_VEHICLE_MAKE: formData?.make ? formData?.make : "",
          OM_VEHICLE_MODEL: formData?.model ? formData?.model : "",
          OM_VEHICLE_ENGINE_NO: formData?.engineNo ? formData?.engineNo : "",
          OM_VEHICLE_RATING_CC: formData?.assetRating
            ? Number(formData?.assetRating)
            : 0,
          OM_VEHICLE_FUEL_CAPACITY: formData?.fuelCapacity
            ? Number(formData?.fuelCapacity)
            : 0,
          OM_VEHICLE_GROSS_WT: formData?.grossWeight
            ? Number(formData?.grossWeight)
            : 0,
          OM_VEHICLE_CARRYING_CAP: formData?.carryingCapacity
            ? Number(formData?.carryingCapacity)
            : 0,
          OM_VEHICLE_REG_DATE: formData?.registrationDate
            ? moment(formData?.registrationDate)?.format("YYYY/MM/DD")
            : "",
          OM_VEHICLE_NAME_REGISTRATION: formData?.registrationName
            ? formData?.registrationName
            : "",
          OM_VEHICLE_ADDRESS_ON_REG1: formData?.addrOnReg
            ? formData?.addrOnReg
            : "",
          OM_VEHICLE_ADDRESS_ON_REG2: "",
          OM_VEHICLE_CLIENT_OWNED: formData?.clientAsset === true ? 1 : 0,
          OM_VEHICLE_CLIENT_CODE: formData?.client ? formData?.client : "",
          OM_VEHICLE_TRAILER_ATTACHED_YES_NO:
            formData?.trailerAttached === true ? 1 : 0,
          OM_VEHICLE_TRAILER_ATTACHED: formData?.trailer1
            ? formData?.trailer1
            : "",
          OM_VEHICLE_TRAILER_ATTACHED_2: formData?.trailer2
            ? formData?.trailer2
            : "",
          OM_VEHICLE_TARE_WT: formData?.tareWeight
            ? Number(formData?.tareWeight)
            : 0,
          OM_VEHICLE_LAYOUT: "",
          OM_VEHICLE_TRANSMISSION: formData?.transmission
            ? formData?.transmission
            : "",
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessiontoken,
          },
        },
      );

      if (response.status === 201) {
        alert(`Vehicle Master Saved successfully`);
        setIsLoading(false);
        window.location.reload();
      } else {
        console.error(`Error while saving Vehicle Master`);
        alert(`Error while saving Vehicle Master`);
        setIsLoading(false);
      }
    } catch (error) {
      console.error(`Error while saving Vehicle Master `, error);
      alert(`Error while saving Vehicle Master `, error);
      setIsLoading(false);
    }
  }

  // *************** EXPORT TO EXCEL OR PDF ****************************

    const ExcelStockData = () => {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("REGISTERED VEHICLES");
      const rows = document.querySelectorAll(".table_1 tbody tr");
  
      const columnWidths = [10, 15, 15, 15,15, 15, 15];
  
      // Set column widths for the worksheet
      columnWidths.forEach((width, index) => {
        worksheet.getColumn(index + 1).width = width;
      });
  
      // Add headers
      const headerRow = worksheet.addRow([
        "S NO",
        "REG NO",
        "CHASIS NO",
        "ENGINE NO",
        "MAKE",
        "MODEL",
        "TRAILER",
      ]);
      headerRow.eachCell((cell) => {
        cell.font = { bold: true };
      });
  
      // Add rows from the table
      rows.forEach((row) => {
        const rowData = [];
        row.querySelectorAll("td").forEach((cell) => {
          rowData.push(cell.textContent);
        });
        worksheet.addRow(rowData);
      });
  
      // Create a blob from the workbook
      workbook.xlsx.writeBuffer().then((buffer) => {
        const blob = new Blob([buffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = "REGISTERED_VEHICLES.xlsx";
        link.click();
      });
    };
  
    const PdfStockData = () => {
      const doc = new jsPDF();
  
      doc.text("REGISTERED VEHICLES- Report", 10, 10);
  
      const columns = [
        "S NO",
        "REG NO",
        "CHASIS NO",
        "ENGINE NO",
        "MAKE",
        "MODEL",
        "TRAILER",
      ];
  
      const data = filterRegistration.map((stock,index) => {  
        return [
          index + 1,
          stock.OM_VEHICLE_REG_NO,
          stock.OM_VEHICLE_CHASSIS_NO,
          stock.OM_VEHICLE_ENGINE_NO,
          stock.OM_VEHICLE_MAKE,
          stock.OM_VEHICLE_MODEL,
          stock.OM_VEHICLE_TRAILER_ATTACHED,
        ];
      });
  
      doc.autoTable({
        head: [columns],
        body: data,
        startY: 20,
        showHead: "firstPage",
      });
  
      doc.save("REGISTERED_VEHICLES.pdf");
    };



  if (isLoading) {
    return <LoadingScreen />;
  }

  return (
    <div className="text-xs">
      <div className=" mt-3 bg-gray-100 p-2 m-2 rounded-md">
        {/* 1st Row  */}
        <div className="flex items-center">
          <div className="w-[150px] flex items-center justify-end">
            <button className="flex h-7 items-center lg:ml-2 justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 mb-[1px]">
              Print Truck List
            </button>
          </div>
          <Select
            className="w-40"
            value={
              formData?.vehicleStatus
                ? {
                    value: formData?.vehicleStatus,
                    label: formData?.vehicleStatus,
                  }
                : { value: "", label: "Select Vehicle Status" }
            }
            onChange={(e) => handleChange("vehicleStatus", e.value)}
            options={[
              { value: "", label: "Select Vehicle Status" },
              { value: "ACTIVE", label: "ACTIVE" },
              { value: "INACTIVE", label: "INACTIVE" },
            ]}
          ></Select>
          <span className="lg:ml-2">Engine No:</span>
          <input
            className="w-40 h-7 border border-black rounded-md outline-none transition-colors duration-200 focus:border-blue-500 ml-2"
            type="text"
            value={formData?.engineNo}
            onChange={(e) => handleChange("engineNo", e.target.value)}
          ></input>
          <span className="lg:ml-2">Trailer 1:</span>

          <Select
            className="w-40"
            value={
              formData?.trailer1
                ? { value: formData?.trailer1, label: formData?.trailer1 }
                : { value: "", label: "Select Trailer 1" }
            }
            onChange={(e) => handleChange("trailer1", e.value)}
            // options={[
            //   { value: "", label: "Select Engine No" },
            //   ...vehicleCategorydata?.map((item) => ({
            //     value: item?.OM_VEHICLE_CATEGORY_NAME,
            //     label: item?.OM_VEHICLE_CATEGORY_NAME,
            //   })),
            // ]}
          ></Select>
          <span className="lg:ml-2">Trailer 2:</span>
          <Select
            className="w-40"
            value={
              formData?.trailer2
                ? { value: formData?.trailer2, label: formData?.trailer2 }
                : { value: "", label: "Select Engine No" }
            }
            onChange={(e) => handleChange("trailer2", e.value)}
            // options={[
            //   { value: "", label: "Select Engine No" },
            //   ...vehicleCategorydata?.map((item) => ({
            //     value: item?.OM_VEHICLE_CATEGORY_NAME,
            //     label: item?.OM_VEHICLE_CATEGORY_NAME,
            //   })),
            // ]}
          ></Select>
        </div>

        {/* 2nd Row  */}
        <div className="flex items-center mt-2">
          <span className="lg:ml-2 w-[140px] text-right">
            Registration Number:
          </span>
          <input
            className="w-40 h-7 border border-black rounded-md outline-none transition-colors duration-200 focus:border-blue-500 ml-2"
            type="text"
            value={formData?.registrationNo}
            onChange={(e) => {
              handleChange("registrationNo", e.target.value);
              handleChange("fleetNo", e.target.value);
            }}
            onBlur={() => {
              const isRegAvailable = formData?.histData?.find(
                (item) => item?.OM_VEHICLE_REG_NO === formData?.registrationNo,
              );
              if (isRegAvailable) {
                handleChange("registrationNo", "");
                handleChange("fleetNo", "");
              }
            }}
          ></input>
          <button
            className="flex h-7 items-center lg:ml-2 justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 mb-[1px]"
            onClick={() => handleChange("showRegistration", true)}
          >
            ...
          </button>

          {formData?.showRegistration && (
            <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2  bg-white border border-black lg:h-[500px] h-[80%] lg:w-[1100px] w-[95%] p-1 overflow-y-auto z-[500]">
              <div className="lg:flex lg:flex-row mt-2">
                <p className="text-red-600 lg:ml-2">Search:</p>
                <input
                  className="w-64 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
                  type="text"
                  value={formData?.searchRegistration}
                  onChange={(e) =>
                    handleChange("searchRegistration", e.target.value)
                  }
                ></input>
              </div>
              <button
                className="absolute top-2 right-2 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
                onClick={() => handleChange("showRegistration", false)}
              >
                Close
              </button>
              <div className="visible lg:h-[300px] p-1 z-0 lg:overflow-auto mt-2">
                   <div className="flex justify-end gap-2">
                                    <div className="cursor-pointer">
                                      <RiFileExcel2Line onClick={ExcelStockData} size={25} />
                                    </div>
                                    <div className="cursor-pointer">
                                      <BsFileEarmarkPdf onClick={PdfStockData} size={25} />
                                    </div>
                                  </div>
                <table className="w-auto border border-gray-300 text-sm table_1">
                  <thead class="sticky top-0 w-44">
                    <tr className="bg-[#2b3f5c] text-white text-[12px]">
                      <td className="py-2 px-4  border border-gray-300 text-left">
                        S NO
                      </td>
                      <td className="py-2 px-4  border border-gray-300 text-left">
                        REG NO
                      </td>
                      <td className="py-2 px-4  border border-gray-300 text-left">
                        CHASIS NO
                      </td>
                      <td className="py-2 px-4  border border-gray-300 text-left">
                        ENGINE NO
                      </td>
                      <td className="py-2 px-4  border border-gray-300 text-left">
                        MAKE
                      </td>
                      <td className="py-2 px-4  border border-gray-300 text-left">
                        MODEL
                      </td>
                      <td className="py-2 px-4  border border-gray-300 text-left">
                        TRAILER
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    {filterRegistration.map((row, index) => (
                      <tr
                        className="hover:bg-gray-100 cursor-pointer text-[12px]"
                        key={index}
                        onClick={() => {
                          getDataFromVehicleRegNo(row?.["OM_VEHICLE_REG_NO"]);
                          addItem(row);
                        }}
                      >
                        <td className="py-2 px-4  border border-gray-300 text-right">
                          {index + 1}
                        </td>
                        <td className="py-2 px-4  border border-gray-300 text-left">
                          {row?.["OM_VEHICLE_REG_NO"]
                            ? row?.["OM_VEHICLE_REG_NO"]
                            : ""}
                        </td>
                        <td className="py-2 px-4  border border-gray-300 text-left">
                          {row?.["OM_VEHICLE_CHASSIS_NO"]
                            ? row?.["OM_VEHICLE_CHASSIS_NO"]
                            : ""}
                        </td>
                        <td className="py-2 px-4  border border-gray-300 text-left">
                          {row?.["OM_VEHICLE_ENGINE_NO"]
                            ? row?.["OM_VEHICLE_ENGINE_NO"]
                            : ""}
                        </td>
                        <td className="py-2 px-4  border border-gray-300 text-left">
                          {row?.["OM_VEHICLE_MAKE"]
                            ? row?.["OM_VEHICLE_MAKE"]
                            : ""}
                        </td>
                        <td className="py-2 px-4  border border-gray-300 text-left">
                          {row?.["OM_VEHICLE_MODEL"]
                            ? row?.["OM_VEHICLE_MODEL"]
                            : ""}
                        </td>
                        <td className="py-2 px-4  border border-gray-300 text-left">
                          {row?.["OM_VEHICLE_TRAILER_ATTACHED"]
                            ? row?.["OM_VEHICLE_TRAILER_ATTACHED"]
                            : ""}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          <span className="lg:ml-2">Color of Body:</span>
          <Select
            className="w-40"
            value={
              formData?.colorOfBody
                ? { value: formData?.colorOfBody, label: formData?.colorOfBody }
                : { value: "", label: "Select Color Of Body" }
            }
            onChange={(e) => handleChange("colorOfBody", e.value)}
            // options={[
            //   { value: "", label: "Select Engine No" },
            //   ...vehicleCategorydata?.map((item) => ({
            //     value: item?.OM_VEHICLE_CATEGORY_NAME,
            //     label: item?.OM_VEHICLE_CATEGORY_NAME,
            //   })),
            // ]}
          ></Select>

          <span className="lg:ml-2 lg:mr-2">Trailer :</span>
          <input
            type="checkbox"
            checked={formData?.trailer}
            onChange={(e) => handleChange("trailer", !formData?.trailer)}
          ></input>
          <span className="lg:ml-2 lg:mr-2">Trailer Attached :</span>
          <input
            type="checkbox"
            checked={formData?.trailerAttached}
            onChange={(e) =>
              handleChange("trailerAttached", !formData?.trailerAttached)
            }
          ></input>
          <span className="lg:ml-2">Attached Trailer Type:</span>
          <input
            className="w-40 h-7 border border-black rounded-md outline-none transition-colors duration-200 focus:border-blue-500 ml-2"
            type="text"
            value={formData?.attachedTrailerType}
            onChange={(e) =>
              handleChange("attachedTrailerType", e.target.value)
            }
          ></input>
        </div>

        {/* 3rd Row  */}
        <div className="flex items-center mt-2">
          <span className="lg:ml-2 w-[140px] text-right">Chasis/S No:</span>
          <input
            className="w-40 h-7 border border-black rounded-md outline-none transition-colors duration-200 focus:border-blue-500 ml-2"
            type="text"
            value={formData?.chasisNo}
            onChange={(e) => handleChange("chasisNo", e.target.value)}
          ></input>
          <span className="lg:ml-2 w-[140px] text-right">Fleet No:</span>
          <input
            className="w-40 h-7 border border-black rounded-md outline-none transition-colors duration-200 focus:border-blue-500 ml-2"
            type="text"
            value={formData?.fleetNo}
            onChange={(e) => handleChange("fleetNo", e.target.value)}
          ></input>
          <span className="lg:ml-2 w-[140px] text-right">Asset Category:</span>
          <Select
            className="w-40"
            value={
              formData?.assetCategory
                ? {
                    value: formData?.assetCategory,
                    label: formData?.assetCategory,
                  }
                : { value: "", label: "Select Asset Category" }
            }
            onChange={(e) => handleChange("assetCategory", e.value)}
            options={[
              { value: "", label: "Select Asset Category" },
              ...vehicleCategorydata?.map((item) => ({
                value: item?.OM_VEHICLE_CATEGORY_NAME,
                label: item?.OM_VEHICLE_CATEGORY_NAME,
              })),
            ]}
          ></Select>
          <button
            className="flex h-7 items-center lg:ml-2 justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 mb-[1px]"
            onClick={() => handleChange("assetCategory", "")}
          >
            R
          </button>
          <button
            className="flex h-7 items-center lg:ml-2 justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 mb-[1px]"
            onClick={() => setShowVehicleCategory(true)}
          >
            N
          </button>

          {showVehicleCategory && (
            <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2  bg-white border border-black lg:h-[500px] h-[80%] lg:w-[1100px] w-[95%] p-1 overflow-y-auto z-[500]">
              <header className="header__of__main lg:flex justify-between items-end px-3">
                <h1 className="header__of__page">
                  {"VEHICLE RELATED-VEHICLE CATEGORY"}
                </h1>
              </header>

              <div className="flex gap-2 mt-2 items-center text-gray-700 pl-2">
                <IoDocumentOutline
                  size={24}
                  className="text-blue-800  hover:text-blue-900 transition-all duration-200 drop-shadow-md"
                />
                <FaSave
                  size={24}
                  className="text-green-400 hover:text-green-500 transition-all duration-200 drop-shadow-md"
                />
                <GiCrossMark
                  size={24}
                  className="text-red-400 hover:text-red-500 transition-all duration-200 drop-shadow-md"
                />
                <IoPrintSharp
                  size={24}
                  className="text-purple-400 hover:text-purple-500 transition-all duration-200 drop-shadow-md"
                />
              </div>

              <aside className="visible lg:h-[300px] p-1 z-0 lg:overflow-auto mt-2">
                <table className="w-auto border border-gray-300 text-sm">
                  <thead class="sticky top-0 w-44">
                    <tr className="bg-[#2b3f5c] text-white text-[12px]">
                      <td className="py-2 px-4  border border-gray-300 text-right">
                        S NO
                      </td>
                      <td className="py-2 px-4  border border-gray-300 text-left">
                        CATEGORY
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    {" "}
                    {vehicleCategorydata.map((row, index) => (
                      <tr
                        className="hover:bg-gray-100 cursor-pointer text-[12px]"
                        key={index}
                        onClick={() => {
                          setVehicleCategoryVC(row?.OM_VEHICLE_CATEGORY_NAME);
                          setselectedRowIndexVC(index);
                        }}
                      >
                        <td className="py-2 px-4  border border-gray-300 text-right">
                          {index + 1}
                        </td>
                        <td className="py-2 px-4  border border-gray-300 text-left">
                          {row.OM_VEHICLE_CATEGORY_NAME
                            ? row.OM_VEHICLE_CATEGORY_NAME
                            : "N/A"}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </aside>

              <div className="lg:flex lg:flex-row justify-between items-center text-xs mt-3 bg-gray-100 p-2 m-2 rounded-md">
                <div className="flex">
                  <p className="text-red-600 mr-2">Category :</p>
                  <input
                    className="w-64 h-7 border border-black rounded-md outline-none transition-colors duration-200 focus:border-blue-500 ml-2"
                    type="text"
                    value={VehicleCategoryVC}
                    onChange={(e) => setVehicleCategoryVC(e.target.value)}
                  ></input>
                </div>
                <div className="flex gap-2">
                  <button
                    className="flex h-7 items-center justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 mb-[1px]
                       
                       "
                    onClick={() => {
                      if (!VehicleCategoryVC) {
                        alert("Kindly Supply Category");
                        return;
                      } else {
                        const category = vehicleCategorydata?.find(
                          (item) =>
                            item?.OM_VEHICLE_CATEGORY_NAME ===
                            VehicleCategoryVC,
                        );
                        if (category) {
                          alert("This Category is available");
                          return;
                        } else {
                          AddToGridVC();
                        }
                      }
                    }}
                  >
                    Add
                  </button>
                  <button
                    className=" flex h-7 items-center justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 mb-[1px]"
                    onClick={() => {
                      if (selectedRowIndexVC !== null) {
                        const categoryLinked = vehicleDataVC?.find(
                          (item) => item?.OM_VEHICLE_TYPE === VehicleCategoryVC,
                        );
                        if (categoryLinked) {
                          alert("This Category is Linked to Vehicle");
                          return;
                        } else {
                          RemoveFromGridVC();
                        }
                      } else {
                        RemoveFromGridVC();
                      }
                    }}
                  >
                    Remove
                  </button>
                </div>
              </div>

              <button
                className="absolute top-2 right-2 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
                onClick={() => setShowVehicleCategory(false)}
              >
                Close
              </button>
            </div>
          )}
        </div>

        {/* 4th Row  */}
        <div className="flex items-center mt-2">
          <span className="lg:ml-2 w-[140px] text-right">Type of Body:</span>
          <Select
            className="w-40"
            value={
              formData?.typeOfBody
                ? { value: formData?.typeOfBody, label: formData?.typeOfBody }
                : { value: "", label: "Select Type Of Body" }
            }
            onChange={(e) => handleChange("typeOfBody", e.value)}
            // options={[
            //   { value: "", label: "Select Type Of Body" },
            //   ...vehicleCategorydata?.map((item) => ({
            //     value: item?.OM_VEHICLE_CATEGORY_NAME,
            //     label: item?.OM_VEHICLE_CATEGORY_NAME,
            //   })),
            // ]}
          ></Select>
          <span className="lg:ml-2 w-[140px] text-right">Subcon:</span>
          <input
            className="w-96 h-7 border border-black rounded-md outline-none transition-colors duration-200 focus:border-blue-500 ml-2"
            type="text"
            value={formData?.subcon}
            onChange={(e) => handleChange("subcon", e.target.value)}
          ></input>
          <button
            className="flex h-7 items-center lg:ml-2 justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 mb-[1px]"
            onClick={() => handleChange("showSubCon", true)}
          >
            ...
          </button>

          {formData?.showSubCon && (
            <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2  bg-white border border-black lg:h-[500px] h-[80%] lg:w-[1100px] w-[95%] p-1 overflow-y-auto z-[500]">
              <div className="lg:flex lg:flex-row mt-2">
                <p className="text-red-600 lg:ml-2">Search:</p>
                <input
                  className="w-64 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
                  type="text"
                  value={formData?.subconSearch}
                  onChange={(e) => handleChange("subconSearch", e.target.value)}
                ></input>
              </div>
              <button
                className="absolute top-2 right-2 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
                onClick={() => handleChange("showSubCon", false)}
              >
                Close
              </button>
              <div className="visible lg:h-[300px] p-1 z-0 lg:overflow-auto mt-2">
                <table className="w-auto border border-gray-300 text-sm">
                  <thead class="sticky top-0 w-44">
                    <tr className="bg-[#2b3f5c] text-white text-[12px]">
                      <td className="py-2 px-4  border border-gray-300 text-left">
                        VENDOR CODE
                      </td>
                      <td className="py-2 px-4  border border-gray-300 text-left">
                        VENDOR NAME
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    {filterSubCon.map((row, index) => (
                      <tr
                        className="hover:bg-gray-100 cursor-pointer text-[12px]"
                        key={index}
                        onClick={() => {
                          handleChange("subcon", row?.["VENDOR NAME"]);
                          handleChange("showSubCon", false);
                        }}
                      >
                        <td className="py-2 px-4  border border-gray-300 text-left">
                          {row?.["VENDOR CODE"] ? row?.["VENDOR CODE"] : ""}
                        </td>
                        <td className="py-2 px-4  border border-gray-300 text-left">
                          {row?.["VENDOR NAME"] ? row?.["VENDOR NAME"] : ""}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          <input
            type="checkbox"
            className="ml-10"
            checked={formData?.subconContractingAsset}
            onChange={(e) =>
              handleChange(
                "subconContractingAsset",
                !formData?.subconContractingAsset,
              )
            }
          ></input>
          <span className="lg:ml-2">Sub contracting Asset</span>
        </div>

        {/* 5th Row  */}
        <div className="flex items-center mt-2">
          <span className="lg:ml-2 w-[140px] text-right">Make:</span>
          <Select
            className="w-40"
            value={
              formData?.make
                ? { value: formData?.make, label: formData?.make }
                : { value: "", label: "Select Make" }
            }
            onChange={(e) => handleChange("make", e.value)}
            options={[
              { value: "", label: "Select Make" },
              ...makeData?.map((item) => ({
                value: item?.MAKE,
                label: item?.MAKE,
              })),
            ]}
          ></Select>
          <button
            className="flex h-7 items-center lg:ml-2 justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 mb-[1px]"
            onClick={() => handleChange("make", "")}
          >
            R
          </button>
          <button
            className="flex h-7 items-center lg:ml-2 justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 mb-[1px]"
            onClick={() => setShowMakes(true)}
          >
            N
          </button>

          {showMakes && (
            <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2  bg-white border border-black lg:h-[500px] h-[80%] lg:w-[1100px] w-[95%] p-1 overflow-y-auto z-[500]">
              <header className="header__of__main lg:flex justify-between items-end px-3">
                <h1 className="header__of__page">
                  {"VEHICLE RELATED-VEHICLE MAKE"}
                </h1>
              </header>

              <div className="flex gap-2 mt-2 items-center text-gray-700 pl-2">
                <IoDocumentOutline
                  size={24}
                  className="text-blue-800  hover:text-blue-900 transition-all duration-200 drop-shadow-md"
                />
                <FaSave
                  size={24}
                  className="text-green-400 hover:text-green-500 transition-all duration-200 drop-shadow-md"
                />
                <GiCrossMark
                  size={24}
                  className="text-red-400 hover:text-red-500 transition-all duration-200 drop-shadow-md"
                />
                <IoPrintSharp
                  size={24}
                  className="text-purple-400 hover:text-purple-500 transition-all duration-200 drop-shadow-md"
                />
              </div>

              <aside className="visible lg:h-[300px] p-1 z-0 lg:overflow-auto mt-2">
            <table className="w-auto border border-gray-300 text-sm">
              <thead class="sticky top-0 w-44">
                <tr className="bg-[#2b3f5c] text-white text-[12px]">
                
                      <td className="py-2 px-4  border border-gray-300 text-right">S NO</td>
                      <td className="py-2 px-4  border border-gray-300 text-left">VEHICLE MAKE</td>
                    </tr>
                  </thead>
                  <tbody>
                    {makeData.map((row, index) => (
                      <tr
                        className="hover:bg-gray-100 cursor-pointer text-[12px]"
                    key={index}
                        onClick={() => {
                          setVehicleMakeMAKE(row?.MAKE);
                          setselectedRowIndex(index);
                        }}
                      >
                        <td className=" py-2 px-4  border border-gray-300 text-right">{index + 1}</td>
                        <td className=" py-2 px-4  border border-gray-300 text-left">
                          {row.MAKE ? row.MAKE : "N/A"}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </aside>

              <div className="lg:flex lg:flex-row justify-between items-center text-xs mt-3 bg-gray-100 p-2 m-2 rounded-md">
                <div className="flex">
                  <p className="text-red-600 mr-2">Make :</p>
                  <input
                    className="w-64 h-7 border border-black rounded-md outline-none transition-colors duration-200 focus:border-blue-500 ml-2"
                    type="text"
                    value={vehicleMakeMAKE}
                    onChange={(e) => {
                      if (e.target.value !== "") {
                        setVehicleMakeMAKE(e.target.value);
                        getDataFromMake(e.target.value);
                      } else {
                        setVehicleMakeMAKE(e.target.value);
                      }
                    }}
                  ></input>
                </div>
                <div className="flex gap-2">
                  <button
                    className="flex h-7 items-center justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 mb-[1px]"
                    onClick={() => {
                      if (!vehicleMakeMAKE) {
                        alert("Kindly Supply Make");
                        return;
                      } else {
                        const make = makeData?.find(
                          (item) => item?.MAKE === vehicleMakeMAKE,
                        );
                        if (make) {
                          alert("This Make is available");
                          return;
                        } else {
                          AddToGrid();
                        }
                      }
                    }}
                  >
                    Add
                  </button>
                  <button
                    className=" flex h-7 items-center justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 mb-[1px]"
                    onClick={() => {
                      if (selectedRowIndex !== null) {
                        const makeLinked = makeModelData?.find(
                          (item) => item?.MAKE === vehicleMakeMAKE,
                        );
                        if (makeLinked) {
                          alert("This Make is Linked to Model");
                          return;
                        } else {
                          RemoveFromGrid();
                        }
                      } else {
                        RemoveFromGrid();
                      }
                    }}
                  >
                    Remove
                  </button>
                </div>
              </div>
              <button
                className="absolute top-2 right-2 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
                onClick={() => setShowMakes(false)}
              >
                Close
              </button>
            </div>
          )}

          <button
            className="flex h-7 items-center lg:ml-2 justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 mb-[1px]"
            onClick={() => setShowMakeAndModel(true)}
          >
            Make and Models
          </button>

          {showMakeAndModel && (
            <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2  bg-white border border-black lg:h-[500px] h-[80%] lg:w-[1100px] w-[95%] p-1 overflow-y-auto z-[500]">
              <header className="header__of__main lg:flex justify-between items-end px-3">
                <h1 className="header__of__page">
                  {"VEHICLE RELATED-VEHICLE MAKE TO MODEL"}
                </h1>
              </header>

              <div className="flex gap-2 mt-2 items-center text-gray-700 pl-2">
                <IoDocumentOutline
                  size={24}
                  className="text-blue-800  hover:text-blue-900 transition-all duration-200 drop-shadow-md"
                />
                <FaSave
                  size={24}
                  className="text-green-400 hover:text-green-500 transition-all duration-200 drop-shadow-md"
                />
                <GiCrossMark
                  size={24}
                  className="text-red-400 hover:text-red-500 transition-all duration-200 drop-shadow-md"
                />
                <IoPrintSharp
                  size={24}
                  className="text-purple-400 hover:text-purple-500 transition-all duration-200 drop-shadow-md"
                />
              </div>

              <div className="lg:flex lg:flex-row justify-between items-center text-xs mt-3 bg-gray-100 p-2 m-2 rounded-md">
                <div className="flex">
                  <p className="text-red-600 mr-2">Make :</p>
                  <Select
                    className="w-64"
                    value={
                      vehicleMake
                        ? { value: vehicleMake, label: vehicleMake }
                        : { value: "", label: "Select Make" }
                    }
                    onChange={(e) => {
                      if (e.value !== "") {
                        setVehicleMake(e.value);
                        getDataFromMake(e.value);
                      } else {
                        setVehicleMake(e.value);
                      }
                    }}
                    options={[
                      { value: "", label: "Select Make" },
                      ...makeList?.map((item) => ({
                        value: item?.MAKE,
                        label: item?.MAKE,
                      })),
                    ]}
                  ></Select>
                </div>
              </div>

               <aside className="visible lg:h-[300px] p-1 z-0 lg:overflow-auto mt-2">
            <table className="w-auto border border-gray-300 text-sm">
              <thead class="sticky top-0 w-44">
                <tr className="bg-[#2b3f5c] text-white text-[12px]">
                
                      <td className="py-2 px-4  border border-gray-300 text-right">S NO</td>
                      <td className="py-2 px-4  border border-gray-300 text-left">VEHICLE MODEL</td>
                    </tr>
                  </thead>
                  <tbody>
                    {" "}
                    {data.map((row, index) => (
                      <tr
                       className="hover:bg-gray-100 cursor-pointer text-[12px]"
                     key={index}
                        onClick={() => {
                          setVehicleMake(row?.MAKE);
                          setVehicleModel(row?.MODEL);
                        }}
                      >
                        <td className="py-2 px-4  border border-gray-300 text-right">{index + 1}</td>
                        <td className="py-2 px-4  border border-gray-300 text-left">
                          {row.MODEL ? row.MODEL : "N/A"}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </aside>

              <div className="lg:flex lg:flex-row justify-between items-center text-xs mt-3 bg-gray-100 p-2 m-2 rounded-md">
                <div className="flex">
                  <p className="text-red-600 mr-2">Model :</p>
                  <Select
                    className="w-64"
                    value={
                      vehicleModel
                        ? { value: vehicleModel, label: vehicleModel }
                        : { value: "", label: "Select Model" }
                    }
                    onChange={(e) => setVehicleModel(e.value)}
                    options={[
                      { value: "", label: "Select Model" },
                      ...data?.map((item) => ({
                        value: item?.MODEL,
                        label: item?.MODEL,
                      })),
                    ]}
                  ></Select>
                </div>
                <div className="flex gap-2">
                  <button className="flex h-7 lg:mt-3 items-center justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 mb-[1px]">
                    Add
                  </button>
                  <button className=" flex h-7 lg:mt-3 items-center justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 mb-[1px]">
                    Delete
                  </button>
                </div>
              </div>

              <button
                className="absolute top-2 right-2 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
                onClick={() => setShowMakeAndModel(false)}
              >
                Close
              </button>
            </div>
          )}

          <span className="lg:ml-2">Client:</span>
          <input
            className="w-96 h-7 border border-black rounded-md outline-none transition-colors duration-200 focus:border-blue-500 ml-2"
            type="text"
            value={formData?.client}
            onChange={(e) => handleChange("client", e.target.value)}
          ></input>
          <button
            className="flex h-7 items-center lg:ml-2 justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 mb-[1px]"
            onClick={() => handleChange("showClient", true)}
          >
            ...
          </button>

          {formData?.showClient && (
            <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2  bg-white border border-black lg:h-[500px] h-[80%] lg:w-[1100px] w-[95%] p-1 overflow-y-auto z-[500]">
              <div className="lg:flex lg:flex-row mt-2">
                <p className="text-red-600 lg:ml-2">Search:</p>
                <input
                  className="w-64 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
                  type="text"
                  value={formData?.searchClient}
                  onChange={(e) => handleChange("searchClient", e.target.value)}
                ></input>
              </div>
              <button
                className="absolute top-2 right-2 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
                onClick={() => handleChange("showClient", false)}
              >
                Close
              </button>
              <div className="visible lg:h-[300px] p-1 z-0 lg:overflow-auto mt-2">
                <table className="w-auto border border-gray-300 text-sm">
              <thead class="sticky top-0 w-44">
                <tr className="bg-[#2b3f5c] text-white text-[12px]">
             
                      <td className="py-2 px-4  border border-gray-300 text-left">CLIENT CODE</td>
                      <td className="py-2 px-4  border border-gray-300 text-left">CLIENT NAME</td>
                    </tr>
                  </thead>
                  <tbody>
                    {filterClient.map((row, index) => (
                      <tr
                                            className="hover:bg-gray-100 cursor-pointer text-[12px]"
                        key={index}
                        onClick={() => {
                          handleChange("client", row?.["CLIENT NAME"]);
                          handleChange("showClient", false);
                        }}
                      >
                        <td className="py-2 px-4  border border-gray-300 text-left">
                          {row?.["CLIENT CODE"] ? row?.["CLIENT CODE"] : ""}
                        </td>
                        <td className="py-2 px-4  border border-gray-300 text-left">
                          {row?.["CLIENT NAME"] ? row?.["CLIENT NAME"] : ""}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          <input
            type="checkbox"
            className="ml-10"
            checked={formData?.clientAsset}
            onChange={(e) =>
              handleChange("clientAsset", !formData?.clientAsset)
            }
          ></input>
          <span className="lg:ml-2">Client Asset</span>
        </div>

        {/* 6th Row  */}
        <div className="flex items-center mt-2">
          <span className="lg:ml-2 w-[140px] text-right">
            Asset Rating(CC):
          </span>
          <input
            className="w-40 h-7 border border-black rounded-md outline-none transition-colors duration-200 focus:border-blue-500 ml-2"
            type="text"
            value={formData?.assetRating}
            onChange={(e) => handleChange("assetRating", e.target.value)}
          ></input>
          <span className="lg:ml-2 w-[140px] text-right">Transmission:</span>
          <Select
            className="w-40"
            value={
              formData?.transmission
                ? {
                    value: formData?.transmission,
                    label: formData?.transmission,
                  }
                : { value: "", label: "Select TransMission" }
            }
            onChange={(e) => handleChange("transmission", e.value)}
            options={[
              { value: "", label: "Select TransMission" },
              { value: "AUTOMATIC", label: "AUTOMATIC" },
              { value: "MANUAL", label: "MANUAL" },
            ]}
          ></Select>
          <span className="lg:ml-2 w-[140px] text-right">Model:</span>
          <Select
            className="w-40"
            value={
              formData?.model
                ? { value: formData?.model, label: formData?.model }
                : { value: "", label: "Select Model" }
            }
            onChange={(e) => handleChange("model", e.value)}
            options={[
              { value: "", label: "Select Model" },
              ...modelData?.map((item) => ({
                value: item?.MODEL,
                label: item?.MODEL,
              })),
            ]}
          ></Select>

          <button
            className="flex h-7 items-center lg:ml-2 justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 mb-[1px]"
            onClick={() => handleChange("model", "")}
          >
            R
          </button>
          <button
            className="flex h-7 items-center lg:ml-2 justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 mb-[1px]"
            onClick={() => setShowModel(true)}
          >
            N
          </button>
          {showModel && (
            <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2  bg-white border border-black lg:h-[500px] h-[80%] lg:w-[1100px] w-[95%] p-1 overflow-y-auto z-[500]">
              <header className="header__of__main lg:flex justify-between items-end px-3">
                <h1 className="header__of__page">
                  {"VEHICLE RELATED-VEHICLE MODEL"}
                </h1>
              </header>

              <div className="flex gap-2 mt-2 items-center text-gray-700 pl-2">
                <IoDocumentOutline
                  size={24}
                  className="text-blue-800  hover:text-blue-900 transition-all duration-200 drop-shadow-md"
                />
                <FaSave
                  size={24}
                  className="text-green-400 hover:text-green-500 transition-all duration-200 drop-shadow-md"
                />
                <GiCrossMark
                  size={24}
                  className="text-red-400 hover:text-red-500 transition-all duration-200 drop-shadow-md"
                />
                <IoPrintSharp
                  size={24}
                  className="text-purple-400 hover:text-purple-500 transition-all duration-200 drop-shadow-md"
                />
              </div>

           <aside className="visible lg:h-[300px] p-1 z-0 lg:overflow-auto mt-2">
            <table className="w-auto border border-gray-300 text-sm">
              <thead class="sticky top-0 w-44">
                <tr className="bg-[#2b3f5c] text-white text-[12px]">
               
                      <td className="py-2 px-4  border border-gray-300 text-right">S NO</td>
                      <td className="py-2 px-4  border border-gray-300 text-left">VEHICLE MODEL</td>
                    </tr>
                  </thead>
                  <tbody>
                    {modelData.map((row, index) => (
                      <tr
                       className="hover:bg-gray-100 cursor-pointer text-[12px]"
                     key={index}
                        onClick={() => {
                          setVehicleModelMODEL(row?.MODEL);
                          setselectedRowIndexMODEL(index);
                        }}
                      >
                        <td className="py-2 px-4  border border-gray-300 text-right">{index + 1}</td>
                        <td className="py-2 px-4  border border-gray-300 text-left">
                          {row.MODEL ? row.MODEL : "N/A"}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </aside>

              <div className="lg:flex lg:flex-row justify-between items-center text-xs mt-3 bg-gray-100 p-2 m-2 rounded-md">
                <div className="flex">
                  <p className="text-red-600 mr-2">Model :</p>
                  <input
                    className="w-64 h-7 border border-black rounded-md outline-none transition-colors duration-200 focus:border-blue-500 ml-2"
                    type="text"
                    value={vehicleModelMODEL}
                    onChange={(e) => setVehicleModelMODEL(e.target.value)}
                  ></input>
                </div>
                <div className="flex gap-2">
                  <button
                    className="flex h-7 items-center justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 mb-[1px]"
                    onClick={() => {
                      if (!vehicleModelMODEL) {
                        alert("Kindly Supply Model");
                        return;
                      } else {
                        const model = modelData?.find(
                          (item) => item?.MODEL === vehicleModelMODEL,
                        );
                        if (model) {
                          alert("This Model is available");
                          return;
                        } else {
                          AddToGridMODEL();
                        }
                      }
                    }}
                  >
                    Add
                  </button>
                  <button
                    className=" flex h-7 items-center justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 mb-[1px]"
                    onClick={() => {
                      if (selectedRowIndexMODEL !== null) {
                        const modelLinked = makeModelData?.find(
                          (item) => item?.MODEL === vehicleModelMODEL,
                        );
                        if (modelLinked) {
                          alert("This Model is Linked to Make");
                          return;
                        } else {
                          RemoveFromGridMODEL();
                        }
                      } else {
                        RemoveFromGridMODEL();
                      }
                    }}
                  >
                    Remove
                  </button>
                </div>
              </div>
              <button
                className="absolute top-2 right-2 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
                onClick={() => setShowModel(false)}
              >
                Close
              </button>
            </div>
          )}
        </div>

        {/* 7th Row  */}
        <div className="flex items-center mt-2">
          <span className="lg:ml-2 w-[140px] text-right">Gross Wt(KG):</span>
          <input
            className="w-40 h-7 border border-black rounded-md outline-none transition-colors duration-200 focus:border-blue-500 ml-2"
            type="text"
            value={formData?.grossWeight}
            onChange={(e) => handleChange("grossWeight", e.target.value)}
          ></input>
          <span className="lg:ml-2 w-[140px] text-right">
            Single/Double Diff:
          </span>
          <Select
            className="w-40"
            value={
              formData?.singleDouble
                ? {
                    value: formData?.singleDouble,
                    label: formData?.singleDouble,
                  }
                : { value: "", label: "Select Single/Double Diff" }
            }
            onChange={(e) => handleChange("singleDouble", e.value)}
            options={[
              { value: "", label: "Select Single/Double Diff" },
              { value: "SINGLE", label: "SINGLE" },
              { value: "DOUBLE", label: "DOUBLE" },
            ]}
          ></Select>

          <span className="lg:ml-2 w-[140px] text-right">
            Manufacturing Year:
          </span>
          <input
            className="w-40 h-7 border border-black rounded-md outline-none transition-colors duration-200 focus:border-blue-500 ml-2"
            type="text"
            value={formData?.manufacturingYear}
            onChange={(e) => handleChange("manufacturingYear", e.target.value)}
          ></input>
        </div>

        {/* 8th Row  */}
        <div className="flex items-center mt-2">
          <span className=" w-[150px] text-right">Carrying Capacity(KG):</span>
          <input
            className="w-40 h-7 border border-black rounded-md outline-none transition-colors duration-200 focus:border-blue-500 ml-2"
            type="text"
            value={formData?.carryingCapacity}
            onChange={(e) => handleChange("carryingCapacity", e.target.value)}
          ></input>
          <span className="lg:ml-2 w-[140px] text-right">Department:</span>
          <Select
            className="w-40"
            value={
              formData?.department
                ? { value: formData?.department, label: formData?.department }
                : { value: "", label: "Select Department" }
            }
            onChange={(e) => handleChange("department", e.value)}
            // options={[
            //   { value: "", label: "Select Department" },
            //   ...vehicleCategorydata?.map((item) => ({
            //     value: item?.OM_VEHICLE_CATEGORY_NAME,
            //     label: item?.OM_VEHICLE_CATEGORY_NAME,
            //   })),
            // ]}
          ></Select>

          <span className="lg:ml-2 w-[140px] text-right">Fuel Capacity:</span>
          <input
            className="w-40 h-7 border border-black rounded-md outline-none transition-colors duration-200 focus:border-blue-500 ml-2"
            type="text"
            value={formData?.fuelCapacity}
            onChange={(e) => handleChange("fuelCapacity", e.target.value)}
          ></input>
        </div>

        {/* 9th Row  */}
        <div className="flex items-center mt-2">
          <span className="lg:ml-2 w-[140px] text-right">Trailer Type:</span>

          <Select
            className="w-48"
            value={
              formData?.trailerType
                ? { value: formData?.trailerType, label: formData?.trailerType }
                : { value: "", label: "Select Trailer Type" }
            }
            onChange={(e) => handleChange("trailerType", e.value)}
            options={[
              { value: "", label: "Select Trailer Type" },
              ...trailerTypedata?.map((item) => ({
                value: item?.TRAILERTYPE,
                label: item?.TRAILERTYPE,
              })),
            ]}
          ></Select>
          <button
            className="flex h-7 items-center lg:ml-2 justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 mb-[1px]"
            onClick={() => setShowTrailerType(true)}
          >
            New
          </button>

          {showTrailerType && (
            <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2  bg-white border border-black lg:h-[500px] h-[80%] lg:w-[1100px] w-[95%] p-1 overflow-y-auto z-[500]">
              <header className="header__of__main lg:flex justify-between items-end px-3">
                <h1 className="header__of__page">
                  {"VEHICLE RELATED-TRAILER TYPE MASTER"}
                </h1>
              </header>

              <div className="flex gap-2 mt-2 items-center text-gray-700 pl-2">
                <IoDocumentOutline
                  size={24}
                  className="text-blue-800  hover:text-blue-900 transition-all duration-200 drop-shadow-md"
                />
                <FaSave
                  size={24}
                  className="text-green-400 hover:text-green-500 transition-all duration-200 drop-shadow-md"
                />
                <GiCrossMark
                  size={24}
                  className="text-red-400 hover:text-red-500 transition-all duration-200 drop-shadow-md"
                />
                <IoPrintSharp
                  size={24}
                  className="text-purple-400 hover:text-purple-500 transition-all duration-200 drop-shadow-md"
                />
              </div>

<aside className="visible lg:h-[300px] p-1 z-0 lg:overflow-auto mt-2">
            <table className="w-auto border border-gray-300 text-sm">
              <thead class="sticky top-0 w-44">
                <tr className="bg-[#2b3f5c] text-white text-[12px]">
                 
                      <td className="py-2 px-4  border border-gray-300 text-right">S NO</td>
                      <td className="py-2 px-4  border border-gray-300 text-left">TRAILER TYPE</td>
                    </tr>
                  </thead>
                  <tbody>
                    {trailerTypedata.map((row, index) => (
                      <tr
                        className="hover:bg-gray-100 cursor-pointer text-[12px]"
                    key={index}
                        onClick={() => {
                          setTrailerTypeTT(row?.TRAILERTYPE);
                          setselectedRowIndexTT(index);
                        }}
                      >
                        <td className="py-2 px-4  border border-gray-300 text-right">{index + 1}</td>
                        <td className="py-2 px-4  border border-gray-300 text-left">
                          {row.TRAILERTYPE ? row.TRAILERTYPE : ""}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </aside>

              <div className="lg:flex lg:flex-row justify-between items-center text-xs mt-3 bg-gray-100 p-2 m-2 rounded-md">
                <div className="flex">
                  <p className="text-red-600 mr-2">Trailer Type :</p>
                  <input
                    className="w-64 h-7 border border-black rounded-md outline-none transition-colors duration-200 focus:border-blue-500 ml-2"
                    type="text"
                    value={trailerTypeTT}
                    onChange={(e) => setTrailerTypeTT(e.target.value)}
                  ></input>
                </div>
                <div className="flex gap-2">
                  <button
                    className="flex h-7 lg:mt-3 items-center justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 mb-[1px]"
                    onClick={() => {
                      if (!trailerTypeTT) {
                        alert("Kindly Supply Trailer");
                        return;
                      } else {
                        const trailer = trailerTypedata?.find(
                          (item) => item?.TRAILERTYPE === trailerTypeTT,
                        );
                        if (trailer) {
                          alert("This Trailer is available");
                          return;
                        } else {
                          AddToGridTT();
                        }
                      }
                    }}
                  >
                    Add
                  </button>
                  <button
                    className=" flex h-7 lg:mt-3 items-center justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 mb-[1px]"
                    onClick={() => {
                      if (selectedRowIndexTT !== null) {
                        const trailerLinked = vehicleDataTT?.find(
                          (item) =>
                            item?.OM_VEHICLE_TRAILER_TYPE === trailerTypeTT,
                        );
                        if (trailerLinked) {
                          alert("This Trailer is Linked to Vehicle");
                          return;
                        } else {
                          RemoveFromGridTT();
                        }
                      } else {
                        RemoveFromGridTT();
                      }
                    }}
                  >
                    Remove
                  </button>
                </div>
              </div>

              <button
                className="absolute top-2 right-2 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
                onClick={() => setShowTrailerType(false)}
              >
                Close
              </button>
            </div>
          )}

          <button
            className="flex h-7 items-center lg:ml-2 justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 mb-[1px]"
            onClick={() => handleChange("trailerType", "")}
          >
            Refresh
          </button>
          <span className="lg:ml-2">Total Wt(KG):</span>
          <input
            className="w-40 h-7 border border-black rounded-md outline-none transition-colors duration-200 focus:border-blue-500 ml-2"
            type="text"
            value={formData?.totalWeight}
            onChange={(e) => handleChange("totalWeight", e.target.value)}
          ></input>
          <span className="lg:ml-2">Tare Wt(KG):</span>
          <input
            className="w-40 h-7 border border-black rounded-md outline-none transition-colors duration-200 focus:border-blue-500 ml-2"
            type="text"
            value={formData?.tareWeight}
            onChange={(e) => handleChange("tareWeight", e.target.value)}
          ></input>
        </div>

        {/* 10th Row  */}
        <div className="flex items-center mt-2">
          <span className="lg:ml-2 w-[140px] text-right">Tractor Type:</span>
          <Select
            className="w-40"
            value={
              formData?.tractorType
                ? { value: formData?.tractorType, label: formData?.tractorType }
                : { value: "", label: "Select Tractor Type" }
            }
            onChange={(e) => handleChange("tractorType", e.value)}
            // options={[
            //   { value: "", label: "Select Tractor Type" },
            //   ...vehicleCategorydata?.map((item) => ({
            //     value: item?.OM_VEHICLE_CATEGORY_NAME,
            //     label: item?.OM_VEHICLE_CATEGORY_NAME,
            //   })),
            // ]}
          ></Select>
          <span className="lg:ml-2 w-[140px] text-right">Dispatcher:</span>
          <Select
            className="w-40"
            value={
              formData?.dispatcher
                ? { value: formData?.dispatcher, label: formData?.dispatcher }
                : { value: "", label: "Select Dispatcher" }
            }
            onChange={(e) => handleChange("dispatcher", e.value)}
            // options={[
            //   { value: "", label: "Select Tractor Type" },
            //   ...vehicleCategorydata?.map((item) => ({
            //     value: item?.OM_VEHICLE_CATEGORY_NAME,
            //     label: item?.OM_VEHICLE_CATEGORY_NAME,
            //   })),
            // ]}
          ></Select>
          <span className="lg:ml-2 w-[140px] text-right">Driver Name:</span>
          <Select
            className="w-40"
            value={
              formData?.driverName
                ? { value: formData?.driverName, label: formData?.driverName }
                : { value: "", label: "Select Driver Name" }
            }
            onChange={(e) => handleChange("driverName", e.value)}
            // options={[
            //   { value: "", label: "Select Tractor Type" },
            //   ...vehicleCategorydata?.map((item) => ({
            //     value: item?.OM_VEHICLE_CATEGORY_NAME,
            //     label: item?.OM_VEHICLE_CATEGORY_NAME,
            //   })),
            // ]}
          ></Select>

          <button
            className="flex h-7 items-center lg:ml-2 justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 mb-[1px]"
            onClick={() => {
              setFormInput((prev) => ({
                ...prev,
                EMPNAME: formData?.driverName || "",
              }));
              // EMPCODE: item?.["EMPLOYEE CODE"] || "",
              handleChange("showDriver", true);
            }}
          >
            V
          </button>

          {formData?.showDriver && (
            <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2  bg-white border border-black lg:h-[500px] h-[80%] lg:w-[1100px] w-[95%] p-1 overflow-y-auto z-[500]">
              <header className="header__of__main lg:flex justify-between items-end px-3">
                <h1 className="header__of__page">{"Employee Registration"}</h1>
              </header>

              <div className="bg-slate-100 m-1 rounded-md p-1 pb-2 h-auto">
                {/* 1st Line */}
                <div className="lg:flex mt-2">
                  <span className="block">Employee No :</span>
                  <input
                    readOnly
                    className="w-24 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
                    type="text"
                    name="EMPNO"
                    value={empidPass}
                  ></input>

                  <button
                    className="  border border-black bg-[#002d62] text-white rounded-md px-3  lg:ml-1 mr-1 h-7 bg-[#002e62dd] focus:outline-none focus:ring focus:border-blue-300"
                    onClick={() => {
                      setShowEmployees(true);
                    }}
                  >
                    ...
                  </button>

                  {showEmployees && (
                    <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-[600] bg-white border border-black lg:h-[500px] h-[80%] lg:w-[1100px] w-[95%] p-1 overflow-y-auto">
                      <div className="lg:flex lg:flex-row mt-2">
                        <p className="text-red-600 lg:ml-2">Search:</p>
                        <input
                          className="w-64 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
                          type="text"
                          value={searchEmployees}
                          onChange={(e) => {
                            setSearchEmployees(e.target.value);
                          }}
                        ></input>
                      </div>
                      <button
                        className="absolute top-2 right-2 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
                        onClick={() => setShowEmployees(false)}
                      >
                        Close
                      </button>
                      <div className="visible lg:h-[400px] p-1 z-0 lg:overflow-auto mt-2">
                        <table className="w-full border border-gray-300 text-sm">
                          <thead className="sticky top-0">
                            <tr className="bg-[#2b3f5c] text-white text-[12px]">
                              <td className="py-2 px-4 text-left border border-gray-300">
                                Employee No
                              </td>
                              <td className="py-2 px-4 text-left border border-gray-300">
                                Employee Code
                              </td>
                              <td className="py-2 px-4 text-left border border-gray-300">
                                Employee Name
                              </td>
                              <td className="py-2 px-4 text-left border border-gray-300">
                                Telephone
                              </td>
                              <td className="py-2 px-4 text-left border border-gray-300">
                                Email
                              </td>
                              <td className="py-2 px-4 text-left border border-gray-300">
                                National Id
                              </td>
                              <td className="py-2 px-4 text-left border border-gray-300">
                                Designation
                              </td>
                              <td className="py-2 px-4 text-left border border-gray-300">
                                Department
                              </td>
                            </tr>
                          </thead>
                          <tbody>
                            {filterEmployee?.map((item, index) => {
                              return (
                                <tr
                                  className="hover:bg-gray-100 cursor-pointer text-[13px]"
                                  onClick={() => {
                                    setEmpId(item?.[" EMPLOYEE ID"]);

                                    setFormInput((prev) => ({
                                      ...prev,
                                      EMPCODE: item?.["EMPLOYEE CODE"] || "",
                                      EMPNAME: item?.["EMPLOYEE NAME"] || "",
                                      TELEPHONE: item?.["TELEPHONE NO"] || "",
                                      EMAIL: item?.["EMAIL"] || "",
                                      NATIONALID:
                                        item?.["NATIONAL ID NO"] || "",
                                      JOINDATE: item?.["DATE JOINED"] || "",
                                      FREEZE: item?.["EMPLOYEE FREEZE"] ?? 0,
                                      OVERTIME: item?.["OVERTIME"] ?? 0,
                                      ACCOUNTNO: item?.["ACCOUNTNO"] || "",
                                      CASUAL: item?.["CASUAL"] ?? 1,
                                      SUBCONTRACTED:
                                        item?.["SUBCONTRACTED"] ?? 0,
                                      IMAGENAME: item?.["IMAGENAME"] || "",
                                      CONFIRM: item?.["CONFIRM"] ?? 0,
                                      NOTES: item?.["NOTES"] || "",
                                      PORTPASS: item?.["PORTPASS"] ?? 0,
                                      PORTPASSNO: item?.["PORTPASSNO"] || "",
                                    }));
                                    const selectedDesignation = desigVal.find(
                                      (d) =>
                                        d.OM_DESIGNATION_NAME ===
                                        item?.["DESIGNATION"],
                                    );
                                    setDesignation(
                                      selectedDesignation
                                        ? {
                                            label:
                                              selectedDesignation.OM_DESIGNATION_NAME,
                                            value:
                                              selectedDesignation.OM_DESIGNATION_NAME,
                                          }
                                        : null,
                                    );
                                    const selectedDepartment =
                                      DEPARTMENTVal.find(
                                        (d) =>
                                          d.OM_DEPARTMENT_NAME ===
                                          item?.["DEPARTMENT"],
                                      );
                                    setDepartment(
                                      selectedDepartment
                                        ? {
                                            label:
                                              selectedDepartment.OM_DEPARTMENT_NAME,
                                            value:
                                              selectedDepartment.OM_DEPARTMENT_NAME,
                                          }
                                        : null,
                                    );
                                    const selectedVehicle = vehicles.find(
                                      (d) =>
                                        d?.["VEHICLE ALLOCATED"] ===
                                        item?.["VEHICLE REG NO"],
                                    );
                                    setVehicleAllocated(
                                      selectedVehicle
                                        ? {
                                            label:
                                              selectedVehicle?.[
                                                "VEHICLE ALLOCATED"
                                              ],
                                            value:
                                              selectedVehicle?.[
                                                "VEHICLE ALLOCATED"
                                              ],
                                          }
                                        : null,
                                    );
                                    setShowEmployees(false);
                                  }}
                                  key={index}
                                >
                                  <td className="py-2 px-4 text-right border border-gray-300">
                                    {item?.[" EMPLOYEE ID"]
                                      ? item?.[" EMPLOYEE ID"]
                                      : "NA"}
                                  </td>
                                  <td className="py-2 px-4 text-left border border-gray-300">
                                    {item?.["EMPLOYEE CODE"]
                                      ? item?.["EMPLOYEE CODE"]
                                      : "NA"}
                                  </td>
                                  <td className="py-2 px-4 text-left border border-gray-300">
                                    {item?.["EMPLOYEE NAME"]
                                      ? item?.["EMPLOYEE NAME"]
                                      : "NA"}
                                  </td>
                                  <td className="py-2 px-4 text-left border border-gray-300">
                                    {item?.["TELEPHONE NO"]
                                      ? item?.["TELEPHONE NO"]
                                      : "NA"}
                                  </td>
                                  <td className="py-2 px-4 text-right border border-gray-300">
                                    {item.EMAIL ? item.EMAIL : "NA"}
                                  </td>
                                  <td className="py-2 px-4 border border-gray-300">
                                    {item?.["NATIONAL ID NO"]
                                      ? item?.["NATIONAL ID NO"]
                                      : "NA"}
                                  </td>
                                  <td className="py-2 px-4 border border-gray-300">
                                    {item?.["DESIGNATION"]
                                      ? item?.["DESIGNATION"]
                                      : "NA"}
                                  </td>
                                  <td className="py-2 px-4 text-left border border-gray-300">
                                    {item?.["DEPARTMENT"]
                                      ? item?.["DEPARTMENT"]
                                      : "NA"}
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}

                  <span className="block lg:ml-6">Employee Code :</span>
                  <input
                    className="w-40 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
                    type="text"
                    name="EMPCODE"
                    value={formInput.EMPCODE}
                    onChange={(e) => handleInputItem(e)}
                  ></input>

                  <span className="block lg:ml-2">Employee Name :</span>
                  <input
                    className="w-64 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
                    type="text"
                    name="EMPNAME"
                    value={formInput.EMPNAME}
                    onChange={(e) => handleInputItem(e)}
                  ></input>

                  <span className="block lg:ml-2">Account No :</span>
                  <input
                    className="w-32 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
                    type="text"
                    name="ACCOUNTNO"
                    value={formInput.ACCOUNTNO}
                    onChange={(e) => handleInputItem(e)}
                  ></input>
                </div>

                {/* 2nd line  */}
                <div className="lg:flex mt-2">
                  <span className="block">Join Date:</span>
                  <input
                    type="date"
                    name="JOINDATE"
                    // max={new Date().toISOString().split("T")[0]}
                    value={JOINDATE?.split("T")[0]}
                    onChange={(e) => {
                      // setJOINDATE(moment(e.target.value).format("YYYY/MM/DD"));
                      setJOINDATE(e.target.value);
                    }}
                    className="w-36 h-8 border border-black lg:ml-10 p-2 rounded-md focus:outline-none focus:border-blue-500"
                  ></input>
                  <span className="block lg:ml-2">National Id :</span>
                  <input
                    className="w-44 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
                    type="text"
                    name="NATIONALID"
                    value={formInput.NATIONALID}
                    onChange={(e) => handleInputItem(e)}
                  ></input>
                  <span className="block lg:ml-2">Telephone :</span>
                  <input
                    className="w-44 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
                    type="number"
                    name="TELEPHONE"
                    value={formInput.TELEPHONE}
                    onChange={(e) => handleInputItem(e)}
                    onInput={tofixnumber}
                  ></input>
                  <span className="block lg:ml-2">Email :</span>
                  <input
                    className="w-64 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
                    type="EMAIL"
                    name="EMAIL"
                    value={formInput.EMAIL}
                    onChange={(e) => handleInputItem(e)}
                  ></input>
                </div>

                {/* 3rd line  */}
                <div className="lg:flex mt-2">
                  <span className="block">Subcontracted :</span>
                  <div className="radio_btn">
                    <div>
                      <input
                        required
                        className="radio"
                        type="radio"
                        name="SUBCONTRACTED"
                        onChange={(e) => {
                          handleInputItem(e);
                          if (e.target.value === "0") {
                            // If SUBCONTRACTEDED is No, set CASUAL to Yes
                            setFormInput({
                              ...formInput,
                              SUBCONTRACTED: 0,
                              CASUAL: 1,
                            });
                          } else {
                            // If SUBCONTRACTEDED is Yes, set CASUAL to No
                            setFormInput({
                              ...formInput,
                              SUBCONTRACTED: 1,
                              CASUAL: 0,
                            });
                          }
                        }}
                        value={1}
                        checked={formInput.SUBCONTRACTED === 1}
                      />
                      Yes
                    </div>
                    <div>
                      <input
                        required
                        className="radio"
                        type="radio"
                        name="SUBCONTRACTED"
                        onChange={(e) => {
                          handleInputItem(e);
                          if (e.target.value === "1") {
                            // If SUBCONTRACTEDED is Yes, set CASUAL to No
                            setFormInput({
                              ...formInput,
                              SUBCONTRACTED: 1,
                              CASUAL: 0,
                            });
                          } else {
                            // If SUBCONTRACTEDED is No, set CASUAL to Yes
                            setFormInput({
                              ...formInput,
                              SUBCONTRACTED: 0,
                              CASUAL: 1,
                            });
                          }
                        }}
                        value={0}
                        checked={formInput.SUBCONTRACTED === 0}
                      />
                      No
                    </div>
                  </div>

                  <span className="block">Overtime :</span>
                  <div className="radio_btn">
                    <div>
                      <input
                        className="radio"
                        required
                        type="radio"
                        name="OVERTIME"
                        onChange={(e) => handleInputItem(e)}
                        value={Number(1)}
                      />
                      Yes
                    </div>
                    <div>
                      <input
                        className="radio"
                        required
                        type="radio"
                        name="OVERTIME"
                        defaultChecked={true}
                        onChange={(e) => handleInputItem(e)}
                        value={Number(0)}
                      />
                      No
                    </div>
                  </div>

                  <span className="block">Casual :</span>
                  <div className="radio_btn">
                    <div>
                      <input
                        className="radio"
                        required
                        type="radio"
                        name="CASUAL"
                        onChange={(e) => {
                          handleInputItem(e);
                          if (e.target.value === "0") {
                            // If CASUAL is No, set SUBCONTRACTEDED to Yes
                            setFormInput({
                              ...formInput,
                              CASUAL: 0,
                              SUBCONTRACTED: 1,
                            });
                          } else {
                            // If CASUAL is Yes, set SUBCONTRACTEDED to No
                            setFormInput({
                              ...formInput,
                              CASUAL: 1,
                              SUBCONTRACTED: 0,
                            });
                          }
                        }}
                        value={1}
                        checked={formInput.CASUAL === 1}
                      />
                      Yes
                    </div>
                    <div>
                      <input
                        className="radio"
                        required
                        type="radio"
                        name="CASUAL"
                        onChange={(e) => {
                          handleInputItem(e);
                          if (e.target.value === "1") {
                            // If CASUAL is Yes, set SUBCONTRACTEDED to No
                            setFormInput({
                              ...formInput,
                              CASUAL: 1,
                              SUBCONTRACTED: 0,
                            });
                          } else {
                            // If CASUAL is No, set SUBCONTRACTEDED to Yes
                            setFormInput({
                              ...formInput,
                              CASUAL: 0,
                              SUBCONTRACTED: 1,
                            });
                          }
                        }}
                        value={0}
                        checked={formInput.CASUAL === 0}
                      />
                      No
                    </div>
                  </div>

                  <span className="block">Freeze :</span>
                  <div className="radio_btn">
                    <div>
                      <input
                        className="radio"
                        type="radio"
                        name="FREEZE"
                        onChange={(e) => handleInputItem(e)}
                        value={Number(1)}
                      />
                      Yes
                    </div>
                    <div>
                      <input
                        className="radio"
                        type="radio"
                        name="FREEZE"
                        defaultChecked={true}
                        onChange={(e) => handleInputItem(e)}
                        value={Number(0)}
                      />
                      No
                    </div>
                  </div>
                  <span className="block">Confirm :</span>
                  <div className="radio_btn">
                    <div>
                      <input
                        className="radio"
                        type="radio"
                        name="CONFIRM"
                        onChange={(e) => handleInputItem(e)}
                        value={Number(1)}
                      />
                      Yes
                    </div>
                    <div>
                      <input
                        className="radio"
                        type="radio"
                        name="CONFIRM"
                        onChange={(e) => handleInputItem(e)}
                        value={Number(0)}
                        defaultChecked={true}
                      />
                      No
                    </div>
                  </div>
                </div>

                {/* 4th line  */}
                <div className="lg:flex mt-2">
                  <span className="block">Designation :</span>
                  <Select
                    className="input_field text-left uppercase lg:ml-3"
                    value={
                      designation
                        ? {
                            value: designation,
                            label: designation,
                          }
                        : { value: "", label: "Select Designation" }
                    }
                    onChange={setDesignation}
                    options={desigVal.map((data) => ({
                      label: data.OM_DESIGNATION_NAME,
                      value: data.OM_DESIGNATION_NAME,
                    }))}
                  ></Select>

                  <span className="block lg:ml-2">Department :</span>
                  <Select
                    className="input_field text-left uppercase lg:ml-2"
                    value={
                      department
                        ? {
                            value: department,
                            label: department,
                          }
                        : { value: "", label: "Select Department" }
                    }
                    onChange={setDepartment}
                    options={DEPARTMENTVal.map((data) => ({
                      label: data.OM_DEPARTMENT_NAME,
                      value: data.OM_DEPARTMENT_NAME,
                    }))}
                  ></Select>

                  <span className="block lg:ml-2">Vehicle Allocated :</span>
                  <Select
                    className="input_field text-left uppercase lg:ml-2"
                    isDisabled={designation === "" || designation !== "DRIVER"}
                    value={
                      vehicleAllocated
                        ? { label: vehicleAllocated, value: vehicleAllocated }
                        : { label: "select", value: "" }
                    }
                    onChange={setVehicleAllocated}
                    options={vehicles.map((vehi) => ({
                      label: vehi["VEHICLE REG NO"],
                      value: vehi["VEHICLE REG NO"],
                    }))}
                  />
                </div>

                <div className="lg:flex mt-5">
                  <span className="block">Notes :</span>
                  <textarea
                    required
                    rows={3}
                    className="w-[500px] lg:ml-14"
                    type="text"
                    name="NOTES"
                    defaultValue={formInput.NOTES}
                    onChange={(e) => handleInputItem(e)}
                  />
                </div>

                {/* 5th line */}

                <div className="lg:flex justify-between mt-2">
                  <div className="flex">
                    <div className="row">
                      <div className="small-12 medium-2 large-2 columns">
                        <div className="circle">
                          <div className="center__no__data">
                            <div>
                              <img
                                required
                                name="userImg"
                                style={{ fontFamily: "Cursive" }}
                                src={dispPicture}
                                alt="Upload image here"
                                className={dispPicture ? "img" : "profile_pic"}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="camera_upload">
                          <div className="camera__icon">
                            <button
                              className="camera_btn"
                              onClick={() => {
                                const CONFIRMBox = window.confirm(
                                  "Allow access to camera?",
                                );
                                if (CONFIRMBox === true) {
                                  setSection1(false);
                                  setCameraOn(true);
                                  openCamera();
                                } else {
                                  return null;
                                }
                              }}
                            >
                              {" "}
                              <p className="bg-green">
                                <FaCamera />
                              </p>
                            </button>
                          </div>
                          <div>
                            <input
                              style={{ padding: "5px", display: "none" }}
                              id="file"
                              type="file"
                              accept=".png, .jpg, .jpeg"
                              onChange={(e) => {
                                handlePictureUpload(e);
                              }}
                            />
                            <div className="upload_file">
                              <label className="View" htmlFor="file">
                                Upload
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="flex gap-5 lg:mt-40">
                    <button
                      // className="View button"
                      className="flex h-7 items-center justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 mb-[1px]"
                      onClick={() => {
                        window.location.reload();
                      }}
                    >
                      Reset
                    </button>

                    <button
                      // className="View button bg-green"
                      className="flex h-7 items-center justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 mb-[1px]"
                      onClick={(e) => {
                        const CONFIRMBox = window.confirm(
                          "Are you sure all the details are correct?",
                        );
                        if (CONFIRMBox === true) {
                          handleRegister(e);
                        } else {
                          e.preventDefault();
                        }
                      }}
                    >
                      Register
                    </button>
                  </div>
                </div>
              </div>

              {cameraOn ? (
                <div className="camera__align">
                  <video ref={videoRef} />

                  <button
                    className="Capture"
                    onClick={() => {
                      capturePicture();
                    }}
                  >
                    Capture
                  </button>
                  <canvas ref={canvasRef} />
                </div>
              ) : null}
              {captured ? (
                <div>
                  <div>
                    <img className="Image" src={dispPicture} />
                  </div>

                  <div className="camera_btn2">
                    <button
                      className="retake"
                      onClick={() => {
                        retakePicture();
                      }}
                    >
                      Retake
                    </button>
                    <button
                      className="Proceed"
                      onClick={() => {
                        setCameraOn(false);
                        setCaptured(false);
                        setSection1(true);
                      }}
                    >
                      Proceed
                    </button>
                  </div>
                </div>
              ) : null}

              <button
                className="absolute top-2 right-2 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
                onClick={() => handleChange("showDriver", false)}
              >
                Close
              </button>
            </div>
          )}
        </div>

        {/* 11th Row  */}
        <div className="flex items-center mt-2">
          <span className="lg:ml-2 w-[140px] text-right">
            Registration Date:
          </span>
          <input
            className="w-40 h-7 border border-black rounded-md outline-none transition-colors duration-200 focus:border-blue-500 ml-2"
            type="date"
            value={formData?.registrationDate?.split("T")[0]}
            onChange={(e) => handleChange("registrationDate", e.target.value)}
          ></input>
          <span className="lg:ml-2 w-[140px] text-right">
            Registered Country:
          </span>
          <Select
            className="w-40"
            value={
              formData?.registeredCountry
                ? {
                    value: formData?.registeredCountry,
                    label: formData?.registeredCountry,
                  }
                : { value: "", label: "Select Registered Country" }
            }
            onChange={(e) => handleChange("registeredCountry", e.value)}
            // options={[
            //   { value: "", label: "Select Asset Category" },
            //   ...vehicleCategorydata?.map((item) => ({
            //     value: item?.OM_VEHICLE_CATEGORY_NAME,
            //     label: item?.OM_VEHICLE_CATEGORY_NAME,
            //   })),
            // ]}
          ></Select>
          <span className="lg:ml-2 w-[140px] text-right">
            Registration Name:
          </span>
          <input
            className="w-40 h-7 border border-black rounded-md outline-none transition-colors duration-200 focus:border-blue-500 ml-2"
            type="text"
            value={formData?.registrationName}
            onChange={(e) => handleChange("registrationName", e.target.value)}
          ></input>
          <button className="flex h-7 items-center lg:ml-2 justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 mb-[1px]">
            Unallocate Driver
          </button>
        </div>

        {/* 12th Row  */}
        <div className="flex items-center mt-2">
          <span className="lg:ml-2 w-[140px] text-right">Addr.on Reg:</span>
          <input
            className="w-40 h-7 border border-black rounded-md outline-none transition-colors duration-200 focus:border-blue-500 ml-2"
            type="text"
            value={formData?.addrOnReg}
            onChange={(e) => handleChange("addrOnReg", e.target.value)}
          ></input>
          <span className="lg:ml-2 w-[140px] text-right">Division:</span>
          <Select
            className="w-40"
            value={
              formData?.division
                ? { value: formData?.division, label: formData?.division }
                : { value: "", label: "Select Division" }
            }
            onChange={(e) => handleChange("division", e.value)}
            // options={[
            //   { value: "", label: "Select Asset Category" },
            //   ...vehicleCategorydata?.map((item) => ({
            //     value: item?.OM_VEHICLE_CATEGORY_NAME,
            //     label: item?.OM_VEHICLE_CATEGORY_NAME,
            //   })),
            // ]}
          ></Select>
        </div>
      </div>

      <div className="mt-1">
        <Tabs
          selectedIndex={selectedTabIndexBottom}
          onSelect={handleTabSelectBottom}
        >
          <TabList className="grid grid-cols-4 gap-1 border-b-2 border-gray-300">
            {bottomtabs.map((tab, index) => (
              <Tab
                key={tab.id}
                className={`px-4 py-1 cursor-pointer text-xs text-red-500 rounded-t-md hover:bg-gray-300 ${
                  index === selectedTabIndexBottom
                    ? "bg-blue-500 text-white"
                    : "bg-gray-200"
                }`}
              >
                {tab.title}
              </Tab>
            ))}
          </TabList>
          <div className="border border-gray-300 rounded-b-md">
            {/* {bottomtabs[selectedTabIndexBottom]?.content} */}
            {bottomtabs.map((tab, index) => (
              <div
                key={tab.id}
                className={
                  index === selectedTabIndexBottom ? "block" : "hidden"
                }
              >
                {tab.content}
              </div>
            ))}
          </div>
        </Tabs>
      </div>
    </div>
  );
};

export default HeaderInformation;
